// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"502":"c3a71a48","8287":"70822d9b"}[chunkId] + ".chunk.css";
};